/**
 * Created by hashinig on 2/11/19.
 */
(function () {
  'use strict';

  angular
    .module('flightScreen')
    .service('flightScreenService', flightScreenService);

  function flightScreenService(RemoteService) {
    var vm = this;

    vm.getFlightScreenData = function(successFn, errorFn){
      RemoteService.searchFlightScreenData().then(
        function (response) {
          if(response.success){
            successFn(response.flightScreenResponse);
          }
        },
        function (error) {
          errorFn(error);
        }
      );
    };


  }
}());
